import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';

import {
  Modal,
  Heading,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary,
  SingleInput
} from '@warrenbrasil/nebraska-web';

interface Props {
  isOpen: boolean;
}
interface Emits {
  (e: 'close'): void;
  (e: 'submit', text: string): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FeedbackModal',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ["close", "submit"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void;
  (e: 'submit', text: string): void;
}), expose: any, slots: any, attrs: any }) {





const text = ref('');

const isSubmitButtonDisabled = computed(() => {
  return text.value?.length === 0;
});

const clearText = () => {
  text.value = '';
};

const handleSubmit = () => {
  emit('submit', text.value);
};

const handleClose = () => {
  emit('close');
};

return { __sfc: true,emit, text, isSubmitButtonDisabled, clearText, handleSubmit, handleClose, Modal, Heading, ButtonContainer, ButtonPrimary, ButtonSecondary, SingleInput }
}

})